import type { ContractorTranslation } from './en';

export const tr: ContractorTranslation = {
  common: {
    cancel: 'İptal',
    save: 'Kaydet',
    retry: 'Tekrar dene',
    download: 'İndir',
    continue: 'Devam',
    yes: 'Evet',
    no: 'Hayır',
    genericError: 'Bir sorun oluştu. Lütfen tekrar deneyin.',
    networkError: "DubForge'a bağlanılamadı. İnternet bağlantınızı kontrol edin.",
  },
  app: {
    tagline: 'Seslendirme görevleri, dosyalar ve incelemeler tek bir yerde.',
    startupFailed: 'DubForge başlatılamadı',
    notFoundTitle: 'Sayfa bulunamadı',
    notFoundBody: 'Bu sayfa yok veya bu sayfaya erişim izniniz yok.',
    goHome: 'Ana sayfaya dön',
    crashTitle: 'Bir sorun oluştu',
    crashBody: 'Sayfayı yeniden yüklemeyi deneyin.',
    reload: 'Yeniden yükle',
  },
  language: {
    label: 'Dil',
    change: 'Dili değiştir',
  },
  welcome: {
    title: "DubForge'a hoş geldiniz",
    body: 'Dilinizi seçin. DubForge ve Discord bildirimleriniz bu dili kullanacak.',
    changeLater: 'Bunu istediğiniz zaman sağ üstteki dil menüsünden değiştirebilirsiniz.',
  },
  nav: {
    myAssignments: 'Görevlerim',
    openMenu: 'Menüyü aç',
    account: 'Hesap',
    notificationEmail: 'Bildirim e-postası',
    signOut: 'Çıkış yap',
    roleAdmin: 'Yönetici',
    roleContractor: 'Seslendirme sanatçısı',
    lightMode: 'Açık mod',
    darkMode: 'Koyu mod',
  },
  login: {
    signIn: 'Discord ile giriş yap',
    onlyInvited: 'Yalnızca kanal sahibinin eklediği Discord hesapları giriş yapabilir.',
    signingIn: 'Giriş yapılıyor…',
    backToSignIn: 'Giriş ekranına dön',
    failed: 'Giriş yapılamadı. Lütfen tekrar deneyin.',
  },
  authErrors: {
    not_invited: "Bu Discord hesabı DubForge'a eklenmemiş. Kanal sahibinden sizi eklemesini isteyin.",
    access_off: 'DubForge erişiminiz kapatıldı.',
    discord_only: 'Yalnızca Discord ile giriş yapabilirsiniz.',
  },
  errors: {
    not_signed_in: 'Oturumunuzun süresi doldu. Lütfen tekrar giriş yapın.',
    access_off: 'DubForge erişiminiz kapatıldı.',
    admins_only: 'Bunu yapma izniniz yok.',
    not_found: 'Bu öğe yok veya artık kullanılamıyor.',
    invalid_request: 'Bu istekte geçersiz bir şey var. Kontrol edip tekrar deneyin.',
    conflict: 'Bu zaten var.',
    already_approved: 'Bu görev zaten onaylandı, başka yükleme yapmanıza gerek yok.',
    not_audio: 'Yalnızca WAV veya MP3 dosyaları yüklenebilir. Yalnızca kendi ses kaydınızı yükleyin.',
    upload_incomplete: 'Yükleme tamamlanmadı. Lütfen tekrar deneyin.',
    discord_unreachable: "Discord'a bağlanılamadı. Lütfen daha sonra tekrar deneyin.",
    server_error: 'Bizim tarafımızda bir sorun oluştu. Lütfen tekrar deneyin.',
  },
  notifications: {
    title: 'Bildirimler',
    openWithCount: 'Bildirimler ({{count}} okunmamış)',
    markAllRead: 'Tümünü okundu olarak işaretle',
    empty: 'Henüz bir şey yok.',
  },
  emailSettings: {
    body: 'Yeni bir görev aldığınızda ve çalışmanız incelendiğinde size e-posta göndeririz.',
    label: 'E-posta adresi',
    fromDiscord: 'Discord hesabınızdan alındı. Başka bir adres kullanmak isterseniz değiştirin.',
    saved: 'E-posta adresi kaydedildi',
    invalid: 'Geçerli bir e-posta adresi girin.',
    missing: 'Henüz bir e-posta adresi yok. Bildirim almak için bir adres ekleyin.',
  },
  status: {
    Assigned: 'Atandı',
    InProgress: 'Devam ediyor',
    Submitted: 'İnceleme bekliyor',
    ChangesRequested: 'Değişiklik istendi',
    Approved: 'Onaylandı',
  },
  assetKind: {
    package: 'Seslendirme paketi (video + ses + SFX)',
    video: 'Referans video (720p)',
    sfx: 'SFX / müzik parçası',
    voice: 'Orijinal ses kaydı',
    script: 'Senaryo',
    other: 'Diğer',
  },
  translation: {
    machine: 'Makine çevirisi',
    showOriginal: 'Orijinali göster',
    showTranslation: 'Çeviriyi göster',
  },
  uploader: {
    progress: '%{{percent}} / {{size}}',
    queued: 'Yükleme sırasında: {{count}}',
    keepOpen: 'Tamamlanana kadar bu sekmeyi açık tutun.',
    cancelled: 'Yükleme iptal edildi',
    done: '{{name}} yüklendi',
    failed: 'Yükleme başarısız oldu: {{error}}',
  },
  my: {
    greeting: 'Merhaba {{name}}',
    subtitle: 'Seslendirme görevleriniz.',
    emptyTitle: 'Henüz göreviniz yok',
    emptyBody: "Size bir video atandığında Discord'dan mesaj alacaksınız ve görev burada görünecek.",
    todo: 'Yapılacaklar',
    waiting: 'İnceleme bekleyenler',
    done: 'Tamamlananlar',
    updated: '{{when}} güncellendi',
  },
  assignment: {
    back: 'Görevlerim',
    dubIn: 'Seslendirme: {{language}}',
    paid: 'Ödendi',
    next: {
      Assigned: 'Kaynak dosyaları indirin, sesinizi kaydedin, ardından ses kaydınızı buraya yükleyin.',
      InProgress: 'Ses kaydınız hazır olduğunda aşağıdan yükleyin.',
      Submitted: "Seslendirmeniz incelemeye gönderildi. İncelendiğinde Discord'dan mesaj alacaksınız.",
      ChangesRequested: 'Değişiklik istendi. Aşağıdaki geri bildirimi okuyun, ardından yeni bir sürüm yükleyin.',
      Approved: 'Onaylandı. Teşekkürler!',
    },
    notes: 'Notlar',
    sourceFiles: 'Kaynak dosyalar',
    noFiles: 'Henüz dosya yüklenmedi.',
    fileInfo: '{{kind}} · {{size}}',
    packageHint: 'Video ve iki ses kanalı içeren tek bir .mp4 dosyası: 1. kanal orijinal replikler, 2. kanal SFX.',
    uploadTitle: 'Ses kaydınızı yükleyin',
    voiceOnlyTitle: 'Yalnızca sizin sesiniz',
    voiceOnlyBody:
      'Yalnızca kaydettiğiniz sesi yükleyin: müzik, ses efekti veya orijinal sesten herhangi bir parça olmasın. Süresinin orijinaliyle aynı olduğundan emin olun.',
    voiceOnlyConfirm: 'Bu dosyada yalnızca replikler var.',
    dropLabel: 'Ses kaydını buraya yükleyin',
    dropHint: 'Yalnızca WAV veya MP3.',
    noteForReviewer: 'İnceleyen kişi için not (isteğe bağlı)',
    lengthTitle: 'Süre uyuşmuyor',
    lengthBody:
      'Dosyanızın süresi {{dub}}, ancak SFX parçasının süresi {{sfx}}. Kaydınız farklı bir noktadan başlıyorsa veya kesilmişse videoyla senkron olmaz. Yine de yüklensin mi?',
    uploadAnyway: 'Yine de yükle',
    chooseAnother: 'Başka dosya seç',
    versions: 'Yüklenen sürümler',
    nothingUploaded: 'Henüz bir şey yüklenmedi.',
    version: 'Sürüm {{version}}',
    reviewApproved: 'Onaylandı',
    reviewChanges: 'Değişiklik istendi',
    reviewPending: 'İnceleme bekliyor',
    yourNote: 'Notunuz:',
    feedback: 'Geri bildirim',
    listen: 'Dinle',
    uploadedOn: '{{date}} · {{size}}',
    length: 'Süre: {{duration}}',
  },
};
